export const state = () => ({
    current_step: 1,
    wage_structure: null,
    salary: 0,
    dates: null,
    factors: null,
});
export const mutations = {
    setCurrentStep(state: any, payload: any) {
        state.current_step = payload;
    },
    setWageStructure(state: any, payload: any) {
        state.wage_structure = payload;
    },
    setSalary(state: any, payload: any) {
        state.salary = payload;
    },
    setDates(state: any, payload: any) {
        state.dates = payload;
    },
    setFactors(state: any, payload: any) {
        state.factors = payload;
    },
};
export const getters = {
    getCurrentStep: (state: any) => state.current_step,
    getWageStructure: (state: any) => state.wage_structure,
    getSalary: (state: any) => state.salary,
    getDates: (state: any) => state.dates,
    getFactors: (state: any) => state.factors,
};
export const actions = {
    createJobOffer(state: any, payload: any) {
        return new Promise((resolve, reject) => {
            const data = {
                salary: state.state.salary,
                start_date: state.state.dates.start_date,
                end_date: state.state.dates.end_date,
                candidate_uuid: payload.data.candidate.uuid,
                candidate_name: `${payload.data.candidate.name} ${payload.data.candidate.surname}`,
                wage_structure: state.state.wage_structure,
                candidate_profile: payload.data.candidate,
                deciding_factors: state.state.factors,
                job_uuid: payload.data.job_uuid,
            };

            this.$axios
                .post(`/api/jobs/${payload.uuid}/job-offers`, data)
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    acceptBursaryApplication(state: any, payload: any) {
        let { job_application_uuid, ...data } = payload;

        data = { ...data, status: 'accepted' };

        return new Promise((resolve, reject) => {
            this.$axios
                .post(`/api/jobs/${job_application_uuid}/job-offers`, data)
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    setCurrentStep(state: any, payload: any) {
        state.commit('setCurrentStep', payload);
    },
    updateWageStructure(state: any, payload: any) {
        state.commit('setWageStructure', payload);
    },
    updateSalary(state: any, payload: any) {
        state.commit('setSalary', payload);
    },
    updateDates(state: any, payload: any) {
        state.commit('setDates', payload);
    },
    updateFactors(state: any, payload: any) {
        state.commit('setFactors', payload);
    },
};
